import React from 'react';
import { Link } from 'react-router-dom';

const featuredByList = [
  {
    title: 'Lodge Owners',
    href: '/partners/lodge-owners',
    imgSrc: 'https://s3.amazonaws.com/honeyguide/assets/placehold.jpg',
    icon: 'icon icon-hg-home',
  },
  {
    title: 'Trekking Guides',
    href: '/partners/guides',
    imgSrc: 'https://s3.amazonaws.com/honeyguide/assets/placehold.jpg',
    icon: 'icon icon-hg-hiker-silhouette-on-mountain',
  },
  {
    title: 'Travel Agents',
    href: '/partners/travel-agents',
    imgSrc: 'https://s3.amazonaws.com/honeyguide/assets/placehold.jpg',
    icon: 'icon icon-hg-user',
  },
  {
    title: 'Non Residential Nepali',
    href: '/partners/non-residential-nepali',
    imgSrc: 'https://s3.amazonaws.com/honeyguide/assets/placehold.jpg',
    icon: 'icon icon-hg-hiking',
  },
  {
    title: 'Travelers & Influencers',
    href: '/partners/bloggers',
    imgSrc: 'https://s3.amazonaws.com/honeyguide/assets/placehold.jpg',
    icon: 'icon icon-hg-trip',
  },
  {
    title: 'Destination Promotion Bodies',
    href: '/partners/destination-promotion-organization',
    imgSrc: 'https://s3.amazonaws.com/honeyguide/assets/placehold.jpg',
    icon: 'icon icon-hg-placeholder-map',
  },
];

const HgPartners = () => (
  <section className="section section--white section--spacer section--hexagon-bg">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <h2 className="text-uppercase text-center section-header">
            PARTNER WITH HONEYGUIDE
          </h2>
          {/* <p className="font-weight-normal text-center">
            Pick your own Lodge. Pick your own Guide. Just book Flights if you want. It is
            your trek afterall. We believe you should be the one calling the shots.
          </p> */}
          <hr className="hr--small mb-4" />
          <div className="row mt-4">
            {featuredByList.map(v => (
              <div key={v.href} className="col-6 col-sm-4 col-md mt-3 mt-md-0">
                <Link
                  to={v.href}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="partners-box"
                >
                  <img src={v.imgSrc} alt="LP" />
                  <div className="partners-title">
                    <i className={v.icon} />
                    <p>{v.title}</p>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default HgPartners;



// WEBPACK FOOTER //
// ./src/screens/Landing/HgPartners.jsx